import { render, staticRenderFns } from "./fixed-service.vue?vue&type=template&id=1585aae0&scoped=true"
import script from "./fixed-service.vue?vue&type=script&lang=js"
export * from "./fixed-service.vue?vue&type=script&lang=js"
import style0 from "./fixed-service.vue?vue&type=style&index=0&id=1585aae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585aae0",
  null
  
)

export default component.exports